import React, { useState, useEffect } from 'react';

const PWAUpdateNotification: React.FC = () => {
    const [showUpdateNotification, setShowUpdateNotification] = useState(false);
    const [waitingWorker, setWaitingWorker] = useState<ServiceWorker | null>(null);

    useEffect(() => {
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.addEventListener('controllerchange', () => {
                // Service worker has been updated, reload the page
                window.location.reload();
            });

            navigator.serviceWorker.ready.then((registration) => {
                registration.addEventListener('updatefound', () => {
                    const newWorker = registration.installing;
                    if (newWorker) {
                        newWorker.addEventListener('statechange', () => {
                            if (newWorker.state === 'installed') {
                                if (navigator.serviceWorker.controller) {
                                    // New service worker available
                                    setWaitingWorker(newWorker);
                                    setShowUpdateNotification(true);
                                } else {
                                    // Service worker installed for the first time
                                    console.log('Service worker installed for the first time');
                                }
                            }
                        });
                    }
                });

                // Check if there's already a waiting service worker
                if (registration.waiting) {
                    setWaitingWorker(registration.waiting);
                    setShowUpdateNotification(true);
                }
            });
        }
    }, []);

    const handleUpdate = () => {
        if (waitingWorker) {
            waitingWorker.postMessage({ type: 'SKIP_WAITING' });
            setShowUpdateNotification(false);
        }
    };

    const handleDismiss = () => {
        setShowUpdateNotification(false);
    };

    if (!showUpdateNotification) return null;

    return (
        <div className="fixed top-4 left-4 right-4 bg-green-600 text-white p-4 rounded-lg shadow-lg z-50 md:max-w-md md:left-auto">
            <div className="flex items-center justify-between">
                <div className="flex-1">
                    <h3 className="font-semibold">Update Available!</h3>
                    <p className="text-sm opacity-90">A new version of the app is ready to install</p>
                </div>
                <div className="flex gap-2 ml-4">
                    <button
                        onClick={handleDismiss}
                        className="px-3 py-1 text-sm bg-transparent border border-white/30 rounded hover:bg-white/10"
                    >
                        Later
                    </button>
                    <button
                        onClick={handleUpdate}
                        className="px-3 py-1 text-sm bg-white text-green-600 rounded font-medium hover:bg-gray-100"
                    >
                        Update
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PWAUpdateNotification;